import type { AuthMnemonic, AuthMnemonicBody, AuthMnemonicKey } from '../types/mnemonic';

/** The message key (and the resend countdown) of an auth response or error body. */
export function getAuthMnemonic(body: AuthMnemonicBody | null | undefined): AuthMnemonic | undefined {
    if (typeof body?.message !== 'string') {
        return undefined;
    }

    // The backend sends a plain string; the cast lets the apps switch over the known keys.
    return { message: body.message as AuthMnemonicKey, secondsRemaining: body.seconds_remaining };
}
